// src/hooks/prompts/useGetInitialFeedbackPrompt.ts

import { AxiosError } from 'axios';
import { useState } from 'react';

import {
  ErrorHttpResponse,
  SuccessHttpResponse,
  HttpConfig,
} from '../../models/https';
import useHttps from '../useHttps';
import { setShowMonthlyPrompt } from '../../redux/slices/preferencesSlice';
import { useAppDisPatch, useAppSelector } from '../../redux/store';

const useGetMonthlyFeedbackPrompt = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const { authData } = useAppSelector((s) => s.auth);
  const [loading, setLoading] = useState(false);

  const onSuccess = ({ data }: SuccessHttpResponse<boolean>) => {
    dispatch(setShowMonthlyPrompt(data));
  };

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.response?.data?.message ??
        'Failed to fetch monthly feedback-prompt preference'
    );
  };

  const getMonthlyFeedbackPrompt = () => {
    if (!authData?.id) {
      console.warn('No user ID – skipping initial prompt fetch');
      return;
    }

    const config: HttpConfig = {
      url: `auth-service/feedback/${authData.id}/can-prompt/monthly`,
      method: 'get',
    };

    request(config, onSuccess, setLoading, onError);
  };

  return { getMonthlyFeedbackPrompt, loading };
};

export default useGetMonthlyFeedbackPrompt;
